export enum SignalType {
    None = 0,
    Attention = 1,
    Confirmation = 2,
    Warning = 3,
    Emergency = 4
}
